import { JSX } from 'react'
import { createRoutesFromElements, createBrowserRouter, Route, RouterProvider } from 'react-router'

import { RxCodesandboxLogo, RxPerson } from 'react-icons/rx'

// eslint-disable-next-line @typescript-eslint/naming-convention
import * as Layout from '@/components/layout.tsx'

// eslint-disable-next-line @typescript-eslint/naming-convention
import Home from './home'

// eslint-disable-next-line @typescript-eslint/naming-convention
import * as Company from './company'
// eslint-disable-next-line @typescript-eslint/naming-convention
import * as Archive from './archive'




export enum Router {
	company = 'company',
	archive = 'archive',

}


export const options: Layout.Options = [
	{ name: '项目管理', path: Router.company, icon: <RxCodesandboxLogo /> },

	{ name: '员工管理', path: Router.archive, icon: <RxPerson /> },

]

export const routes = createRoutesFromElements(
	<Route element={<Layout.Root options={options} />}>
		<Route index element={<Home />} />

		<Route path={Router.company} element={<Company.default />}>
			<Route path={`:${Router.company}`} element={<Company.View deep={1} />}>
				<Route path={`${Router.archive}/:${Router.archive}`} element={<Archive.View deep={2} />} />

			</Route>

		</Route>

		<Route path={Router.archive} element={<Archive.default />}>
			<Route path={`:${Router.archive}`} element={<Archive.View deep={1} />} />

		</Route>

	</Route>,

)

export default function (): JSX.Element
{
	return (
		<RouterProvider router={createBrowserRouter(routes)} />

	)

}
